module.exports = __webpack_public_path__ + "img/tu02.6895f7db.png";